import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './chat.css'; // Asegúrate de tener este archivo de estilos en tu proyecto
import TapTatSVG from '../Iconos/TapTat.svg';
import ChatSVG from '../Iconos/Chat.svg';
import xsvg from '../Iconos/x-circle.svg';
import sendsvg from '../Iconos/Telegram-1.svg';
import { useTranslation } from 'react-i18next';

interface Message {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

const Chatbot: React.FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false); // Estado para controlar la visibilidad del chat
  const [message, setMessage] = useState('');
  const [conversation, setConversation] = useState<Message[]>([]);
  const [response, setResponse] = useState('');

  const toggleChat = () => setIsOpen(!isOpen); // Función para alternar la visibilidad

  const sendPrompt = async () => {
    const userMessage: Message = { role: 'user', content: message };
    const newMessages = [...conversation, userMessage];
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

      console.log(backendUrl);
      
      const res = await axios.post(`${backendUrl}/chatbot`, { messages: newMessages });
      setResponse(res.data.reply);
      const assistantMessage: Message = { role: 'assistant', content: res.data.reply };
      setConversation([...newMessages, assistantMessage]);
      setMessage('');
    } catch (error) {
      console.error('Error al enviar el prompt:', error);
      setResponse('Lo siento, hubo un error al procesar tu solicitud.');
    }
  };
  const messagesEndRef = useRef<null | HTMLLIElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom(); // se ejecuta cuando se actualiza la conversación
  }, [conversation]);

  return (
    <>
      <div className="chat-icons">
        <div className="chat-toggle-button " onClick={toggleChat}>
          <img className="chat-toggle-button pulsing" src={ChatSVG} alt="Icono de Chat" style={{ width: '15%', height: '50%' }} />
          <h2 className="taapt">
            {t('Hola')},<br /> {t('soy')} <span className='taapt-highlight'>Tap-Tat</span>.
          </h2>
        </div>

        {/* Aquí añadimos el bocadillo de texto */}
        <div className="chatbot-bubble">
          <p>Si necesitas algo, estoy aquí para ayudarte. Pincha en el icono.</p>
        </div>

        <img src={TapTatSVG} alt="" style={{ width: '30%', height: '50%' }} />
      </div>

      {isOpen && (
        <div className="chat-container">
          <button className="close-button" onClick={() => setIsOpen(false)}>
            <img src={xsvg} alt="Chat Icon" style={{ width: '100%', height: '100%' }} />
          </button>
          <ul className="chat-messages">
            {conversation.map((msg, index) => (
              <li key={index} className={msg.role === 'assistant' ? 'assistant-message' : 'user-message'}>
                {msg.content}
              </li>
            ))}
            {/* Referencia al final de los mensajes */}
            <li ref={messagesEndRef} className="messages-end-ref" />
          </ul>
          <div className="chat-form-container">
            <textarea
              className="text-input"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Escribe tus dudas aquí"
            />
            <button className="send-button" onClick={sendPrompt}>
              <img src={sendsvg} alt="Chat Icon" style={{ width: '100%', height: '100%' }} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;
